import Vue from "vue";
import "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./registerServiceWorker";
import VueI18n from "vue-i18n";
import arMessages from "./i18n/ar.json";
import VeeValidate from "vee-validate";
import Nprogress from "nprogress";
import Api from "./providers/api.js";
import "nprogress/nprogress.css";
import miniToastr from "mini-toastr";
import VueNotifications from "vue-notifications";
import Vuebar from "vuebar";
import VueTimeago from "vue-timeago";
import StarRating from "vue-star-rating";

Vue.config.productionTip = false;
Vue.prototype.$env = process.env;
Vue.prototype.$api = new Api();

// router on switch
router.beforeEach((to, from, next) => {
  Nprogress.start();
  next();
});
router.afterEach((to, from) => {
  Nprogress.done();
});

Nprogress.configure({ easing: "ease", speed: 500 });

function toast({ title, message, type, timeout, cb }) {
  return miniToastr[type](message, title, timeout, cb);
}

const vueNotificationsOptions = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
};

const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};

miniToastr.init({
  types: toastTypes
});

// use plugins
Vue.use(VueI18n);
Vue.use(VeeValidate);
Vue.use(Vuebar);
Vue.use(VueNotifications, vueNotificationsOptions);
Vue.use(VueTimeago, {
  name: "Timeago", // Component name, `Timeago` by default
  locale: "ar", // Default locale
  // We use `date-fns` under the hood
  // So you can use all locales from it
  locales: {
    ar: require("date-fns/locale/ar")
  }
});

// configure translation
const messages = {
  ar: arMessages
};
const i18n = new VueI18n({
  locale: "ar", // set locale
  messages // set locale messages
});

Vue.mixin({
  computed: {
    environment: function() {
      return process.env.NODE_ENV;
    },
    isProd: function() {
      return this.environment === "production";
    },
    isDev: function() {
      return this.environment === "development";
    },
    user: function() {
      return store.getters.user;
    }
  }
});

Vue.component("star-rating", StarRating);

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
